import { lazy } from "react";
import Loadable from "components/Loadable";
//import Demo from "./components/Demo";

const AuthorList = Loadable(lazy(() => import('features/author/components/List')));
const AuthorPage = Loadable(lazy(() => import('features/author/components/Page')));

const routes = {
  path: "author",
  children: [
    { path: "", element: <AuthorList /> },
    { path: "add", element: <AuthorPage /> },
    { path: "edit/:authorId?", element: <AuthorPage /> },
    //{ path: "demo", element: <Demo /> },
  ],
};

export default routes;
